<template>
  <p :class="[$style.container, {[$style.visible]: isVisible}]"></p>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import store from '@/lib/store'

  const { mapGetters } = createNamespacedHelpers('conference')

  export default {
    data () {
      return {
        user: store.get('user')
      }
    },
    computed: {
      ...mapGetters([
        'callStatus',
        'recordingState'
      ]),
      isVisible () {
        return this.callStatus === 'in-progress' &&
          (this.user.softphoneOutboundRecordPreference || this.recordingState === 'in-progress')
      }
    }
  }
</script>

<style module lang="less" src="./recording-indicator.less"></style>



// WEBPACK FOOTER //
// recording-indicator.vue?f5803dbc